export default (type, attributes) => ({
  data: {
    type,
    attributes,
  },
});
